import request from '@/utils/request'

// 获取用户列表
export const getOperationLists = (data) => {
    return request({
        url: '/user/lists',
        params: data
    })
}

// 获取用户选项列表
export const getOperationOptionLists = (data) => {
    return request({
        url: '/user/option/lists',
        params: data
    })
}

// 用户-详情
export const getOperationDetail = (id) => {
    return request({
        url: `/user/${id}`
    })
}

// 用户-修改
export const putOperation = (data) => {
    return request({
        url: '/user/manage',
        method: 'PUT',
        data
    })
}

// 用户-添加
export const addOperation = (data) => {
    return request({
        url: '/user/manage',
        method: 'POST',
        data
    })
}

// 用户-删除
export const delOperation = (id) => {
    return request({
        url: `/user/${id}`,
        method: 'DELETE'
    })
}

// 用户-启用/禁用/重置密码
export const batchOperation = (params) => {
    return request({
        url: '/user/manage',
        method: 'PATCH',
        data: params
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/user/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/user/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}
